<template>
  <button
    :disabled="loading"
    class="relative inline-block w-full lg:w-auto bg-black rounded-sm hover:bg-grey-darker py-4 px-8 font-semibold text-xs uppercase text-white text-center transition hover:cursor-pointer focus:outline-none"
    @click="$emit('click')"
  >
    <div :class="{ 'pointer-events-none text-black': loading }">
      <slot />
      <transition name="fade">
        <Spinner v-if="loading" class="spinner" />
      </transition>
    </div>
  </button>
</template>

<script>
import Spinner from '@/components/Spinner'

export default {
  components: {
    Spinner,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
button:disabled {
  @apply bg-black cursor-not-allowed;

  &:hover {
    @apply bg-black opacity-50;
  }
}

.spinner {
  left: calc(50% - 8px);
  top: calc(50% - 8px);

  @apply absolute;
}
</style>
